import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ScreenReaderText } from '#/shared/components/Accessibility';
import * as Styled from './styled';

function FavoriteButton({ isFavorite, toggleFavorite, type }) {
  return (
    <Styled.FavoriteButton
      isFavorite={isFavorite}
      onClick={toggleFavorite}
      type={type}
      data-testid="favoriteButton"
    >
      <ScreenReaderText>
        {isFavorite ? (
          <FormattedMessage id="favorites.removetype_acc" values={{ type }} />
        ) : (
          <FormattedMessage id="favorites.addtype_acc" values={{ type }} />
        )}
      </ScreenReaderText>
      <Styled.FavoriteStar $active={isFavorite} />
    </Styled.FavoriteButton>
  );
}

FavoriteButton.propTypes = {
  /** Determines if the button is actively marked as a favorite */
  isFavorite: PropTypes.bool.isRequired,
  /** Toggles the favorite state */
  toggleFavorite: PropTypes.func.isRequired,
  /** Notes the type of favorite being managed */
  type: PropTypes.string,
};

FavoriteButton.defaultProps = {
  type: '',
};

export default FavoriteButton;
